// extracted by mini-css-extract-plugin
module.exports = {"intakeHolder":"IntakeContentHolder_intakeHolder__2lZTX","fadein":"IntakeContentHolder_fadein__25ZBl"};